"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _OrderWriteOff = _interopRequireDefault(require("@/views/order/OrderWriteOff.vue"));
var _order = require("@/api/order");
var _ZBParser = _interopRequireDefault(require("@/components/FormGenerator/components/parser/ZBParser"));
var _orderDetail = _interopRequireDefault(require("./orderDetail"));
var _orderSend = _interopRequireDefault(require("./orderSend"));
var _orderVideoSend = _interopRequireDefault(require("./orderVideoSend"));
var _storePoint = require("@/api/storePoint");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _utils = require("@/utils");
var _store = require("@/api/store");
var _sms = require("@/api/sms");
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default = exports.default = {
  name: 'orderlistDetails',
  components: {
    zbParser: _ZBParser.default,
    detailsFrom: _orderDetail.default,
    orderSend: _orderSend.default,
    orderVideoSend: _orderVideoSend.default,
    OrderWriteOff: _OrderWriteOff.default
  },
  data: function data() {
    return {
      options: [{
        value: 2,
        label: '全部'
      }, {
        value: 0,
        label: '普通订单'
      }, {
        value: 1,
        label: '视频号订单'
      }],
      RefuseVisible: false,
      RefuseData: {},
      orderId: '',
      refundVisible: false,
      refundData: {},
      dialogVisibleJI: false,
      tableDataLog: {
        data: [],
        total: 0
      },
      tableFromLog: {
        page: 1,
        limit: 10,
        orderNo: 0
      },
      LogLoading: false,
      isCreate: 1,
      editData: null,
      dialogVisible: false,
      tableData: {
        data: [],
        total: 0
      },
      listLoading: true,
      //订单状态（all 总数； 未支付 unPaid； 未发货 notShipped；待收货 spike；待评价 bargain；已完成 complete；
      // 待核销 toBeWrittenOff；退款中:refunding；已退款:refunded；已删除:deleted
      tableFrom: {
        status: 'all',
        dateLimit: '',
        orderNo: '',
        deliveryId: '',
        // 物流单号
        searchType: 'all',
        content: '',
        page: 1,
        limit: 20,
        type: 2
      },
      orderChartType: {},
      timeVal: [],
      fromList: this.$constants.fromList,
      fromType: [{
        value: 'all',
        text: '全部'
      }, {
        value: 'info',
        text: '普通'
      }, {
        value: 'pintuan',
        text: '拼团'
      }, {
        value: 'bragin',
        text: '砍价'
      }, {
        value: 'miaosha',
        text: '秒杀'
      }],
      selectionList: [],
      ids: '',
      orderids: '',
      cardLists: [],
      isWriteOff: (0, _utils.isWriteOff)(),
      proType: 0,
      active: false,
      card_select_show: false,
      checkAll: false,
      checkedCities: ['订单号', '订单类型', '收货人', '商品信息', '实际支付', '支付方式', '订单状态', '创建时间'],
      columnData: ['订单号', '订单类型', '收货人', '商品信息', '实际支付', '支付方式', '订单状态', '创建时间'],
      isIndeterminate: true,
      expressListNormal: [],
      //全部物流公司 normal
      expressListElec: [],
      //全部物流公司 elec
      orderDetail: null //订单详情
    };
  },
  mounted: function mounted() {
    this.getList();
    this.getOrderStatusNum();
    // this.getOrderListData();
    if ((0, _permission.checkPermi)(['admin:express:list'])) this.getExpress();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    //重置
    handleReset: function handleReset() {
      this.tableFrom.type = 2;
      this.tableFrom.dateLimit = '';
      this.tableFrom.orderNo = '';
      this.tableFrom.deliveryId = '';
      this.tableFrom.content = '';
      this.tableFrom.searchType = 'all';
      this.timeVal = [];
      this.getList();
      this.getOrderStatusNum();
    },
    isNumber: function isNumber(val) {
      return typeof val === 'number' && !Number.isNaN(val);
    },
    // 物流公司列表
    getExpress: function () {
      var _getExpress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.getExpressList('normal');
            case 1:
              this.expressListNormal = _context.v;
              _context.n = 2;
              return this.getExpressList('elec');
            case 2:
              this.expressListElec = _context.v;
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getExpress() {
        return _getExpress.apply(this, arguments);
      }
      return getExpress;
    }(),
    // 物流公司列表
    getExpressList: function () {
      var _getExpressList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(expressType) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              return _context2.a(2, new Promise(function (resolve, reject) {
                (0, _sms.expressAllApi)({
                  type: expressType
                }).then(function (res) {
                  resolve(res);
                });
              }));
          }
        }, _callee2);
      }));
      function getExpressList(_x) {
        return _getExpressList.apply(this, arguments);
      }
      return getExpressList;
    }(),
    resetFormRefundhandler: function resetFormRefundhandler() {
      this.refundVisible = false;
    },
    resetFormRefusehand: function resetFormRefusehand() {
      this.RefuseVisible = false;
    },
    resetForm: function resetForm(formValue) {
      this.dialogVisible = false;
    },
    // 核销订单
    onWriteOff: function onWriteOff(row) {
      this.$refs.orderWriteOffRef.open(row);
      // this.$modalSure('核销订单吗').then(() => {
      //   writeUpdateApi(row.verifyCode).then(() => {
      //     this.$message.success('核销成功');
      //     this.tableFrom.page = 1;
      //     this.getList();
      //   });
      // });
    },
    seachList: function seachList() {
      this.tableFrom.page = 1;
      this.getList();
      this.getOrderStatusNum();
    },
    // 拒绝退款
    RefusehandleClose: function RefusehandleClose() {
      this.RefuseVisible = false;
    },
    onOrderRefuse: function onOrderRefuse(row) {
      this.orderids = row.orderId;
      this.RefuseData = {
        orderId: row.orderId,
        reason: ''
      };
      this.RefuseVisible = true;
    },
    RefusehandlerSubmit: function RefusehandlerSubmit(formValue) {
      var _this = this;
      (0, _order.orderRefuseApi)({
        orderNo: this.orderids,
        reason: formValue.reason
      }).then(function (data) {
        _this.$message.success('操作成功');
        _this.RefuseVisible = false;
        _this.getList();
      });
    },
    // 立即退款
    refundhandleClose: function refundhandleClose() {
      this.refundVisible = false;
    },
    onOrderRefund: function onOrderRefund(row) {
      this.refundData = {
        orderId: row.orderId,
        amount: row.payPrice,
        type: ''
      };
      this.orderids = row.orderId;
      this.refundVisible = true;
    },
    refundhandlerSubmit: function refundhandlerSubmit(formValue) {
      var _this2 = this;
      (0, _order.orderRefundApi)({
        amount: formValue.amount,
        orderNo: this.orderids
      }).then(function (data) {
        _this2.$message.success('操作成功');
        _this2.refundVisible = false;
        _this2.getList();
      });
    },
    // 详情接口
    getDetail: function getDetail(id) {
      var _this3 = this;
      (0, _order.orderDetailApi)({
        orderNo: id
      }).then(function (res) {
        _this3.orderDetail = res;
        _this3.editData = {
          orderId: id,
          totalPrice: _this3.orderDetail.proTotalPrice,
          totalPostage: _this3.orderDetail.payPostage,
          payPrice: _this3.orderDetail.payPrice,
          payPostage: _this3.orderDetail.payPostage
        };
        _this3.loading = true;
      }).catch(function () {
        _this3.orderDetail = null;
        _this3.loading = false;
      });
    },
    //修改快递单号
    handleUpdateNumber: function handleUpdateNumber(row) {
      this.orderId = row.orderId;
      this.$refs.send.modals = true;
      this.$refs.send.loading = true;
      //默认加载Normal物流公司
      this.$refs.send.express = this.expressListNormal;
      this.getDetail(row.orderId);
    },
    // 发送
    sendOrder: function sendOrder(row) {
      this.orderDetail = null;
      if (row.type === 0) {
        this.$refs.send.modals = true;
        //默认加载Normal物流公司
        this.$refs.send.express = this.expressListNormal;
        this.$refs.send.sheetInfo();
      } else {
        this.$refs.videoSend.modals = true;
        if (!JSON.parse(sessionStorage.getItem('videoExpress'))) this.$refs.videoSend.companyGetList();
      }
      this.orderId = row.orderId;
    },
    // 订单删除
    handleDelete: function handleDelete(row, idx) {
      var _this4 = this;
      if (row.isDel) {
        this.$modalSure().then(function () {
          (0, _order.orderDeleteApi)({
            orderNo: row.orderId
          }).then(function () {
            _this4.$message.success('删除成功');
            if (_this4.tableData.data.length === 1 && _this4.tableFrom.page > 1) _this4.tableFrom.page = _this4.tableFrom.page - 1;
            _this4.getList();
          });
        });
      } else {
        this.$confirm('您选择的的订单存在用户未删除的订单，无法删除用户未删除的订单！', '提示', {
          confirmButtonText: '确定',
          type: 'error'
        });
      }
    },
    // 详情
    onOrderDetails: function onOrderDetails(id) {
      this.orderId = id;
      this.$refs.orderDetail.getDetail(id);
      this.$refs.orderDetail.dialogVisible = true;
    },
    // 订单记录
    onOrderLog: function onOrderLog(id) {
      this.tableFromLog.limit = 10;
      this.orderId = id;
      this.dialogVisibleJI = true;
      this.getOrderStatusList(id);
    },
    //订单记录请求列表
    getOrderStatusList: function getOrderStatusList(id) {
      var _this5 = this;
      this.LogLoading = true;
      this.tableFromLog.orderNo = id;
      (0, _order.orderLogApi)(this.tableFromLog).then(function (res) {
        _this5.tableDataLog.data = res.list;
        _this5.tableDataLog.total = res.total;
        _this5.LogLoading = false;
      }).catch(function () {
        _this5.LogLoading = false;
      });
    },
    pageChangeLog: function pageChangeLog(page) {
      this.tableFromLog.page = page;
      this.getOrderStatusList(this.orderId);
    },
    handleSizeChangeLog: function handleSizeChangeLog(val) {
      this.tableFromLog.limit = val;
      this.getOrderStatusList(this.orderId);
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    // 备注
    onOrderMark: function onOrderMark(row) {
      var _this6 = this;
      this.$modalPrompt('textarea', '订单备注', null, '订单备注').then(function (V) {
        (0, _order.orderMarkApi)({
          mark: V,
          orderNo: row.orderId
        }).then(function () {
          _this6.$message.success('操作成功');
          _this6.getList();
        });
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.selectionList = val;
      var data = [];
      this.selectionList.map(function (item) {
        data.push(item.orderId);
      });
      this.ids = data.join(',');
    },
    // 选择时间
    selectChange: function selectChange(tab) {
      this.timeVal = [];
      this.tableFrom.page = 1;
      this.getList();
      this.getOrderStatusNum();
      // this.getOrderListData();
    },
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.dateLimit = e ? this.timeVal.join(',') : '';
      this.tableFrom.page = 1;
      this.getList();
      this.getOrderStatusNum();
      // this.getOrderListData();
    },
    // 编辑
    edit: function edit(row) {
      //this.getDetail(row.orderId);
      this.orderId = row.orderId;
      this.editData = {
        orderId: row.orderId,
        proTotalPrice: row.proTotalPrice,
        beforePayPrice: row.beforePayPrice ? row.beforePayPrice : row.payPrice,
        payPrice: row.payPrice
      };
      this.dialogVisible = true;
    },
    handlerSubmit: function handlerSubmit(formValue) {
      var _this7 = this;
      var data = {
        orderNo: formValue.orderId,
        payPrice: formValue.payPrice
      };
      (0, _order.updatePriceApi)(data).then(function (data) {
        _this7.$message.success('编辑成功');
        _this7.dialogVisible = false;
        _this7.getList();
      });
    },
    // 列表
    getList: function getList() {
      var _this8 = this;
      this.listLoading = true;
      (0, _order.orderListApi)(this.tableFrom).then(function (res) {
        _this8.tableData.data = res.list || [];
        _this8.tableData.total = res.total;
        _this8.listLoading = false;
        _this8.checkedCities = _this8.$cache.local.has('order_stroge') ? _this8.$cache.local.getJSON('order_stroge') : _this8.checkedCities;
      }).catch(function () {
        _this8.listLoading = false;
      });
    },
    // 数据统计
    getOrderListData: function getOrderListData() {
      var _this9 = this;
      (0, _order.orderListDataApi)({
        dateLimit: this.tableFrom.dateLimit
      }).then(function (res) {
        _this9.cardLists = [{
          name: '订单数量',
          count: res.count,
          color: '#1890FF',
          class: 'one',
          icon: 'icondingdan'
        }, {
          name: '订单金额',
          count: res.amount,
          color: '#A277FF',
          class: 'two',
          icon: 'icondingdanjine'
        }, {
          name: '微信支付金额',
          count: res.weChatAmount,
          color: '#EF9C20',
          class: 'three',
          icon: 'iconweixinzhifujine'
        }, {
          name: '余额支付金额',
          count: res.yueAmount,
          color: '#1BBE6B',
          class: 'four',
          icon: 'iconyuezhifujine2'
        }];
      });
    },
    // 获取各状态数量
    getOrderStatusNum: function getOrderStatusNum() {
      var _this0 = this;
      (0, _order.orderStatusNumApi)({
        dateLimit: this.tableFrom.dateLimit,
        type: this.tableFrom.type,
        orderNo: this.tableFrom.orderNo,
        deliveryId: this.tableFrom.deliveryId,
        searchType: this.tableFrom.searchType,
        content: this.tableFrom.content
      }).then(function (res) {
        _this0.orderChartType = res;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    exports: function exports() {
      var data = {
        dateLimit: this.tableFrom.dateLimit,
        orderNo: this.tableFrom.orderNo,
        deliveryId: this.tableFrom.deliveryId,
        status: this.tableFrom.status,
        type: this.tableFrom.type
      };
      (0, _store.orderExcelApi)(data).then(function (res) {
        window.open(res.fileName);
      });
    },
    renderHeader: function renderHeader(h) {
      var _this1 = this;
      return h("p", [h("span", {
        "style": "padding-right:5px;"
      }, ["\u64CD\u4F5C"]), h("i", {
        "class": "el-icon-setting",
        "on": {
          "click": function click() {
            return _this1.handleAddItem();
          }
        }
      })]);
    },
    handleAddItem: function handleAddItem() {
      if (this.card_select_show) {
        this.$set(this, 'card_select_show', false);
      } else if (!this.card_select_show) {
        this.$set(this, 'card_select_show', true);
      }
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedCities = val ? this.columnData : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.columnData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnData.length;
    },
    checkSave: function checkSave() {
      this.card_select_show = false;
      this.$modal.loading('正在保存到本地，请稍候...');
      this.$cache.local.setJSON('order_stroge', this.checkedCities);
      setTimeout(this.$modal.closeLoading(), 1000);
    },
    //打印小票
    onOrderPrint: function onOrderPrint(data) {
      var _this10 = this;
      (0, _order.orderPrint)(data.orderId).then(function (res) {
        _this10.$modal.msgSuccess('打印成功');
      }).catch(function (error) {
        _this10.$modal.msgError(error.message);
      });
    },
    onWriteOffSuccess: function onWriteOffSuccess() {
      this.tableFrom.page = 1;
      this.getList();
    }
  }
};